module.exports = __webpack_public_path__ + "static/media/score.0d5994cf.svg";